import { computed, inject, Injectable, signal, Signal } from "@angular/core";
import { Wallet } from "../../models/wallet.model";
import { EntityApiEnum } from "src/app/config/entity-api.enum";
import { ConfirmationDialogService } from "../utility/confirmation-dialog.service";
import { AsyncApiService } from "@spike/core";

@Injectable({ providedIn: 'root' })
export class WalletStoreService {
    private readonly confirmationDialogService = inject(ConfirmationDialogService);
    private readonly asyncApiService = inject(AsyncApiService);
    private readonly apiEnum = EntityApiEnum.FIN_WALLET;
    private list = signal<Wallet[]>([]);

    constructor() {
        // Chiamata automatica all'avvio del service
        this.reload();
    }

    public async save(entity: Wallet):Promise<Wallet>{
        const walletSaved = await this.asyncApiService.save<Wallet>(this.apiEnum, entity, entity.finWalletId ?? undefined);
        await this.reload();
        return walletSaved;
    }

    public async deleteById(id: number) {
        await new Promise<void>((resolve) => {
        this.confirmationDialogService.show('Sei sicuro di voler eliminare questa etichetta?', async () => {
            await this.deleteByIdConfirmed(id);
            resolve(); // Notifica che l'operazione è completata
        });
        });
    }

    public async deleteByIdConfirmed(id: number) {
        await this.asyncApiService.deleteById(this.apiEnum, id);
        await this.reload();
    }

    public getList(): Signal<Wallet[]> {
        return this.list.asReadonly();
    }

    private async reload(){
        const res = await this.asyncApiService.selectAll<Wallet>(this.apiEnum);
        this.list.set(res);
    }
        
    public findReactive(id: number): Signal<Wallet | undefined> {
        return computed(() => {
            if (!id) return undefined;
            // Il computed reagisce automaticamente ai cambiamenti di list()
            return this.list().find(x => x.finWalletId === id);
        });
    }
}